import { service } from '../../../../helpers/http'

export const ActionGetCourses = ({ dispatch }, payload) => {

    return service({
        module: 'domainCourse',
        action: 'getCourses',
        payload: payload
    })

}

export const ActionGetCoursesOfferedInWorkTime = ({ dispatch }, payload) => {

    return service({
        module: 'domainCourse',
        action: 'getCoursesOfferedInWorkTime',
        payload: payload
    })

}

export const ActionPostCourses = ({ dispatch }, payload) => {

    return service({
        module: 'domainCourse',
        action: 'postCourses',
        payload: payload
    })
    
}

export const ActionPutCourses = ({ dispatch }, payload) => {

    return service({
        module: 'domainCourse',
        action: 'putCourses',
        payload: payload
    })
    
}

export const ActionDeleteCourses = ({ dispatch }, payload) => {

    return service({
        module: 'domainCourse',
        action: 'deleteCourses',
        payload: payload
    })
    
}